import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Optional,
  Output,
  SkipSelf,
  forwardRef
} from "@angular/core";
import {
  ControlContainer,
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from "@angular/forms";
import { Option } from "@interfaces/option";
import { DropdownChangeEvent } from "primeng/dropdown";
import { v4 } from "uuid";

@Component({
  selector: "app-select",
  templateUrl: "./select.component.html",
  styleUrls: ["./select.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SelectComponent)
    }
  ]
})
export class SelectComponent implements ControlValueAccessor, OnInit {
  @Input() options: Option<unknown>[] = [];
  @Input() formControlName = "";
  @Input() id = v4();
  @Input() label = "";
  @Input() value = "";
  @Input() placeholder = "Selecione uma opção";
  @Input() disabled = false;
  @Input() filter = false;
  @Input() editable = false;
  @Input() virtualScroll = false;
  @Input() virtualScrollItemSize = 38;
  @Output() outputChange = new EventEmitter<DropdownChangeEvent>();

  @HostBinding("style.opacity")
  get opacity() {
    return this.input?.disabled ? 0.25 : 1;
  }

  get input() {
    return this.controlContainer.control?.get(this.formControlName);
  }

  onChange?: () => void;
  onTouch?: () => void;

  control: FormGroup = new FormGroup({});

  constructor(
    @Optional() @SkipSelf() public controlContainer: ControlContainer
  ) {}

  ngOnInit(): void {
    const control = this.controlContainer.control;
    if (!control) return;
    this.control = control as FormGroup;
  }

  writeValue(value: string): void {
    this.value = value;
  }
  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
